import dynamic from "next/dynamic";

export const DynamicHero028 = dynamic(() => import("./Hero028"), {
  suspense: true,
});
